module.exports = __webpack_public_path__ + "img/logo.3b8cb933.png";